import { Box, CheckBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import { getRandomAlphaNumString } from '@jfs/utils'
import { useRef } from 'react'
import { AutoSizer, CellMeasurer, CellMeasurerCache, List as VirualizedList } from 'react-virtualized'
import { SnakeCase } from '../../util/util'
import { styles } from './styles'

export const MidFilterItem = ({ hide, mode, updateFilters, filterData, checkSelected }: any) => {
  const themedStyle = styles()
  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      fixedHeight: true,
    }),
  )
  if (hide) {
    return null
  }
  const filtersObj = filterData[mode]
  const keys = Object.keys(filtersObj)
  const isMidFilter = mode === 'mid'
  const _renderItem = ({ item, style }: any) => {
    const handleFilter = (): void => {
      updateFilters(mode, item)
    }
    return (
      <Box
        onPress={handleFilter}
        testID="handleFilter"
        {...themedStyle.childContainer}
        {...style}
        key={getRandomAlphaNumString(3)}>
        <CheckBox
          checked={checkSelected(mode, item)}
          onChange={handleFilter}
          iconSize={16}
          color={checkSelected(mode, item) ? 'PRIMARY' : 'BLACK_LIGHT'}
        />
        <Spacer size={8} direction="horizontal" />
        {isMidFilter && (
          <Box>
            {!!filtersObj[item]?.businessName && (
              <TextNew type="body12" color="PRIMARY" fontFamily="jiotype-medium">
                {filtersObj[item]?.businessName}
              </TextNew>
            )}
            <TextNew type="body12" color="PRIMARY_GREY" fontFamily="jiotype-medium">
              {filtersObj[item]?.mid ? `MID:${filtersObj[item]?.mid}` : SnakeCase(item)}
            </TextNew>
          </Box>
        )}
      </Box>
    )
  }
  return (
    <Box {...themedStyle.innerContainer}>
      {keys?.length === 0 && (
        <Box pv={24}>
          <Text title={'No records found'} fontFamily={'jiotype-medium'} color={'BLACK_75'} textAlign="center" />
        </Box>
      )}
      {keys?.length > 0 && (
        <Box h={50 * keys?.length} maxHeight={420}>
          <AutoSizer>
            {({ width, height }) => {
              return (
                <VirualizedList
                  width={width}
                  height={height}
                  deferredMeasurementCache={cache.current}
                  rowHeight={50}
                  rowRenderer={({ key, index, style, parent }: any) => {
                    const item = keys[index]
                    return (
                      <CellMeasurer
                        key={key}
                        cache={cache.current}
                        parent={parent}
                        columnIndex={0}
                        rowIndex={index}
                        style={style}>
                        {_renderItem({ item, style })}
                      </CellMeasurer>
                    )
                  }}
                  rowCount={keys.length}
                  overscanRowCount={3}
                />
              )
            }}
          </AutoSizer>
        </Box>
      )}
    </Box>
  )
}
